'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bullets = exports.Dot = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Box = require('@material-ui/core/Box');

var _Box2 = _interopRequireDefault(_Box);

var _styles = require('@material-ui/styles');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var useStyles = (0, _styles.makeStyles)(function () {
  return {
    dot: {
      background: function background(_ref) {
        var dotColor = _ref.dotColor;
        return dotColor;
      },
      width: '8px',
      height: '8px',
      borderRadius: '8px'
    }
  };
});

var Dot = exports.Dot = function Dot(_ref2) {
  var className = _ref2.className,
      color = _ref2.color;

  var classes = useStyles({ dotColor: color });
  return _react2.default.createElement('div', { className: className + ' ' + classes.dot });
};

Dot.defaultProps = {
  className: 'dot'
};
Dot.propTypes = {
  className: _propTypes2.default.string,
  color: _propTypes2.default.string.isRequired
};

var Bullets = function Bullets(_ref3) {
  var items = _ref3.items,
      color = _ref3.color,
      variant = _ref3.variant,
      isNumbering = _ref3.isNumbering,
      props = _objectWithoutProperties(_ref3, ['items', 'color', 'variant', 'isNumbering']);

  return _react2.default.createElement(
    'div',
    props,
    items.map(function (item, key) {
      return _react2.default.createElement(
        _Box2.default,
        { display: 'flex', alignItems: 'baseline', key: item.text },
        isNumbering ? _react2.default.createElement(
          _index.Typography,
          { variant: variant === 'paragraph' ? 'textbody2-reguler' : 'caption', 'data-width': 'auto' },
          key + 1 + '.'
        ) : _react2.default.createElement(Dot, { color: color }),
        _react2.default.createElement(
          _index.Typography,
          { variant: variant === 'paragraph' ? 'textbody2-reguler' : 'caption', 'data-margin-left': '8px' },
          item.text
        )
      );
    })
  );
};

exports.Bullets = Bullets;
Bullets.defaultProps = {
  items: [{
    text: 'Lorem ipsum dolor sit amet consec'
  }],
  color: 'var(--green-400)',
  variant: 'paragraph',
  isNumbering: false
};

Bullets.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string
  })),
  color: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  isNumbering: _propTypes2.default.bool
};

exports.default = Bullets;